import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { CalendarMonth } from 'components/pages/leave-management';
import { theme } from 'styles/theme';
import { Box, Text, Flex } from 'atoms';

const Container = styled(Flex)`
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	margin-top: 80px;
`;

const CalendarNav = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 95%;
	margin: 5px 10px;
	margin-bottom: 10px;
	padding: 0 10px;
	border-radius: 8px;
	background-color: ${(props) => props.theme.colors.white};
`;

const Tab = styled(Text)`
	font-size: 10px;
	padding: 8px 20px;
	border-bottom: 2px solid
		${(props) =>
			props.monthTab === props.month
				? props.theme.colors.CelticBlue
				: props.theme.colors.white};
	:hover {
		color: ${(props) => props.theme.colors.CelticBlue};
		cursor: pointer;
		border-bottom: 2px solid ${(props) => props.theme.colors.CelticBlue};
	}
`;

export default function Calendar() {
	const [month, setMonth] = useState(0);

	return (
		<Container>
			<Flex justifyContent="flex-start" mx="10px" px="5px" width="95%">
				<Text fontSize="8px" px="30px">
					Year
				</Text>
				<Text fontSize="8px" px="30px">
					Month
				</Text>
			</Flex>
			<CalendarNav>
				<Tab monthTab="" color={theme.colors.CelticBlue}>
					{moment().format('yyyy')}
				</Tab>
				<Tab
					monthTab={0}
					month={month}
					onClick={() => setMonth(0)}
					color={theme.colors.CelticBlue}
				>
					{moment().format('MMMM')}
				</Tab>
				<Tab monthTab={1} month={month} onClick={() => setMonth(1)}>
					{moment().add(1, 'M').format('MMMM')}
				</Tab>
				<Tab monthTab={2} month={month} onClick={() => setMonth(2)}>
					{moment().add(2, 'M').format('MMMM')}
				</Tab>
				<Tab monthTab={3} month={month} onClick={() => setMonth(3)}>
					{moment().add(3, 'M').format('MMMM')}
				</Tab>
			</CalendarNav>
			<CalendarMonth selectedMonth={month} />
		</Container>
	);
}
